
import dayjs from 'dayjs';
import Vue, { defineComponent, PropType, ref } from 'vue';
import { BaseButton, BaseModal, BaseAlert } from '@samknows/design-system';
import { useStore } from '@/common/composables/vuex';

import { UserTOS } from '@/common/services/account/termsOfServices';
import { TosConfig } from '@/common/volunteers.config';

export default defineComponent({
  components: {
    BaseButton,
    BaseModal,
    BaseAlert
  },
  props: {
    config: {
      type: Object as PropType<TosConfig>,
      required: true
    }
  },
  setup(props, { emit }) {
    const showError = ref(false);
    const store = useStore();

    async function acceptTerms() {
      showError.value = false;
      const updatedTerms: UserTOS = {
        accepted: true,
        tosVersion: props.config.version,
        locale: Vue.config.lang,
        timestamp: dayjs().valueOf()
      };

      try {
        await store.dispatch('user/updateUserTOS', updatedTerms);
        emit('accept');
      } catch (error) {
        showError.value = true;
        console.error(error);
      }
    }

    return {
      tosLinks: props.config?.terms[Vue.config.lang],
      showError,
      acceptTerms
    };
  }
});
